import styled from '@emotion/styled'

export const Wrapper = styled.div`
  border-top: 1px solid #e9e9e9;
  border-bottom: 1px solid #e9e9e9;
  background-color: #f4f4f4;
  display: flex;
  height: 30px;
  font-size: 10px;
  position: fixed;
  bottom: 0;
  width: 100%;
`

export const RowsInfo = styled.div`
  margin-left: 25px;
  display: flex;
  align-items: center;
  gap: 10px;
`

export const LastUpdatedWrapper = styled.div`
  margin-left: 6px;
  display: flex;
  align-items: center;

  .grid-footer-updated-at {
    opacity: 0;
    margin-left: 5px;
    transition: opacity 0.5s ease-in-out;
  }

  svg:hover + .grid-footer-updated-at {
    opacity: 1;
  }
`
